const keyboardDatePicker = {
  deadline: 'deadline'
};

export default keyboardDatePicker;
